/*
 * KUVAIA - "Multi column slider FINAL" block: PDP-identical Add to bag.
 *
 * The block (blocks/ai_gen_block_88ca560.liquid) already renders the theme's own
 * {% form 'product' %} with data-product-form, but it was missing the
 * <product-form> custom element that Palo Alto uses to intercept the submit,
 * add via AJAX and open the cart drawer. Without it the form did a normal POST
 * and the shopper was redirected to /cart.
 *
 * This wraps those forms in <product-form> at runtime, so Add to bag behaves
 * exactly like the product page. Falls back to its own AJAX add if the theme
 * has no <product-form> element.
 */
(function () {
  'use strict';

  var FORMS = 'form[data-product-form][id^="KvForm-"]';

  function eachForm(fn) {
    Array.prototype.forEach.call(document.querySelectorAll(FORMS), fn);
  }

  function routes() {
    return (window.theme && window.theme.routes) || {};
  }

  /* Preferred path: hand the form to the theme's own product-form element. */
  function wrap(form) {
    if (form.closest('product-form')) return;
    if (form.getAttribute('data-kv-bound')) return;

    var holder = document.createElement('product-form');
    holder.style.display = 'block';
    holder.style.width = '100%';
    form.parentNode.insertBefore(holder, form);
    holder.appendChild(form);
  }

  function drawerToggle() {
    var candidates = document.querySelectorAll('[data-cart-drawer-toggle]');
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest('[data-cart-drawer]')) return candidates[i];
    }
    return null;
  }

  /* Fallback path: only used if <product-form> is not registered. */
  function bindFallback(form) {
    if (form.closest('product-form')) return;
    if (form.getAttribute('data-kv-bound')) return;
    form.setAttribute('data-kv-bound', 'true');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var inside = form.querySelectorAll('[data-add-to-cart], [data-atc]');
      var outside = form.id ? document.querySelectorAll('[form="' + form.id + '"]') : [];
      var errors = form.querySelector('[data-cart-errors-container]');
      var addUrl = routes().cart_add_url || '/cart/add';

      function busy(state) {
        Array.prototype.forEach.call(inside, function (el) { el.disabled = state; });
        Array.prototype.forEach.call(outside, function (el) { el.disabled = state; });
      }

      if (errors) errors.textContent = '';
      busy(true);

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          busy(false);

          if (!result.ok) {
            if (errors) {
              errors.textContent = result.data.description || result.data.message || '';
            }
            return;
          }

          document.dispatchEvent(new CustomEvent('theme:cart:add', {
            bubbles: true,
            detail: { item: result.data }
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

          var toggle = drawerToggle();
          if (toggle) {
            toggle.click();
          } else {
            window.location.href = routes().cart_url || '/cart';
          }
        })
        .catch(function () {
          busy(false);
          form.submit();
        });
    });
  }

  function init() {
    if (window.customElements && window.customElements.get('product-form')) {
      eachForm(wrap);
    } else {
      eachForm(bindFallback);
    }
  }

  function start() {
    if (window.customElements && window.customElements.whenDefined) {
      var settled = false;

      window.customElements.whenDefined('product-form').then(function () {
        settled = true;
        init();
      });

      window.setTimeout(function () {
        if (!settled) init();
      }, 2000);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
